const themeConfig = {
  app: {
    appName: 'User Portal',
    appLogoImage: require('@src/assets/images/logo/logo.png'),
    appLogoLgImage: require('@src/assets/images/logo/splogo-h.png'),
    playOnImage: require('@src/assets/images/icons/play-on.svg').default,
    playOffImage: require('@src/assets/images/icons/play-off.svg').default,
    coachOnImage: require('@src/assets/images/icons/coach-on.svg').default,
    coachOffImage: require('@src/assets/images/icons/coach-off.svg').default,
    adminOnImage: require('@src/assets/images/icons/admin-on.svg').default,
    adminOffImage: require('@src/assets/images/icons/admin-off.svg').default,
    arrowPlayImage: require('@src/assets/images/icons/arrow-play.svg').default,
    arrowCoachImage: require('@src/assets/images/icons/arrow-coach.svg').default,
    renewsIcon: require('@src/assets/images/icons/renews.svg').default,
    enrolsIcon: require('@src/assets/images/icons/enrols.svg').default,
    membersIcon: require('@src/assets/images/icons/members.svg').default,
    subsIcon: require('@src/assets/images/icons/subs.svg').default,
    paysIcon: require('@src/assets/images/icons/payments.svg').default,
    metricsIcon: require('@src/assets/images/icons/metrics.svg').default
  },
  layout: {
    isRTL: false,
    skin: 'light',
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none
    type: 'vertical',
    contentWidth: 'full',
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white'
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: false
  }
}

export default themeConfig
